/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/radar-fetch-client";
import type { CountContactsQueryResponse, CountContactsHeaderParams } from "../../models/contactsController/CountContacts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/radar-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const countContactsQueryKey = () => [{ url: '/contacts/count' }] as const

export type CountContactsQueryKey = ReturnType<typeof countContactsQueryKey>

/**
 * @summary Count the authenticated user's contacts
 * {@link /contacts/count}
 */
export async function countContacts(headers?: CountContactsHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CountContactsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : `/contacts/count`, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function countContactsQueryOptions(headers?: CountContactsHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = countContactsQueryKey()
        return queryOptions<CountContactsQueryResponse, ResponseErrorConfig<Error>, CountContactsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return countContacts(headers, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Count the authenticated user's contacts
 * {@link /contacts/count}
 */
export function useCountContacts<TData = CountContactsQueryResponse, TQueryData = CountContactsQueryResponse, TQueryKey extends QueryKey = CountContactsQueryKey>(headers?: CountContactsHeaderParams, options: 
{
  query?: Partial<QueryObserverOptions<CountContactsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? countContactsQueryKey()
         

         const query = useQuery({
          ...countContactsQueryOptions(headers, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}